import { z } from 'zod'
import { PASSWORD_RULE, REASON_DETAIL_MIN_LENGTH } from '../constants'

/**
 * 엑셀 다운로드 사유 모달 검증 — 옛 `ExcelDownloadReasonModal` 의 zod 스키마를 그대로 옮겼다.
 *
 * 뷰(생성본) 모달에는 [확인] 잠금 슬롯이 없어 이 검증을 `rgr04DownloadModal_ok` 가 한다(가이드 52 §5-A ⑥ — 실패는 throw, 모달 유지).
 * 비밀번호는 BE 계약이다(D9 — 없으면 400). 입력은 뷰 폼 버스 키(reason·detail·password)로 온다.
 */
export const downloadReasonSchema = z.object({
  reasonCode: z.string().min(1, '사유코드를 선택해 주세요.'),
  reasonDetail: z.string().trim().min(REASON_DETAIL_MIN_LENGTH, `상세사유는 ${REASON_DETAIL_MIN_LENGTH}글자 이상 입력해 주세요.`),
  password: z
    .string()
    .min(PASSWORD_RULE.minLength, `비밀번호는 ${PASSWORD_RULE.minLength}자 이상이어야 합니다.`)
    .regex(PASSWORD_RULE.pattern, '비밀번호는 대문자·소문자·숫자·특수문자를 각 1개 이상 포함해야 합니다(공백 불가).'),
})

export type DownloadReason = z.infer<typeof downloadReasonSchema>
